import {
  GET_PRODUCTBLOCK,
  GET_PRODUCTBLOCK_SUCCESS,
  GET_PRODUCTBLOCK_FAIL,
  DELETE_PRODUCTBLOCK,
  DELETE_PRODUCTBLOCK_SUCCESS,
  DELETE_PRODUCTBLOCK_FAIL,
  UPDATE_PRODUCTBLOCK,
  UPDATE_PRODUCTBLOCK_SUCCESS,
  UPDATE_PRODUCTBLOCK_FAIL,
  ADD_NEW_PRODUCTBLOCK,
  ADD_PRODUCTBLOCK_SUCCESS,
  ADD_PRODUCTBLOCK_FAIL,
  PRODUCTBLOCK_LOADING,
  PRODUCTBLOCK_RESET,
  PRODUCTBLOCK_RESET_CREATE
} from "./actionType";

export const resetProductBlockState = (actionType) => ({
  type: PRODUCTBLOCK_RESET,
  payload: { actionType },
});


export const resetProductBlockCreateState = (actionType) => ({
  type: PRODUCTBLOCK_RESET_CREATE,
  payload: { actionType }
});

export const getProductBlockSuccess = (actionType, data) => ({
  type: GET_PRODUCTBLOCK_SUCCESS,
  payload: { actionType, data },
});

export const getProductBlockFail = (actionType, error) => ({
  type: GET_PRODUCTBLOCK_FAIL,
  payload: { actionType, error },
});

export const getProductBlock = data => ({
  type: GET_PRODUCTBLOCK,
  payload: data,
});

export const getProductBlockLoading = () => ({
  type: PRODUCTBLOCK_LOADING
});

export const deleteProductBlock = data => ({
  type: DELETE_PRODUCTBLOCK,
  payload: data,
});

export const deleteProductBlockSuccess = data => ({
  type: DELETE_PRODUCTBLOCK_SUCCESS,
  payload: data,
});

export const deleteProductBlockFail = error => ({
  type: DELETE_PRODUCTBLOCK_FAIL,
  payload: error,
});

export const updateProductBlock = data => ({
  type: UPDATE_PRODUCTBLOCK,
  payload: data,
});

export const updateProductBlockFail = error => ({
  type: UPDATE_PRODUCTBLOCK_FAIL,
  payload: error,
});

export const updateProductBlockSuccess = data => ({
  type: UPDATE_PRODUCTBLOCK_SUCCESS,
  payload: data,
});

export const addNewProductBlock = data => ({
  type: ADD_NEW_PRODUCTBLOCK,
  payload: data,
});

export const addProductBlockSuccess = data => ({
  type: ADD_PRODUCTBLOCK_SUCCESS,
  payload: data,
});

export const addProductBlockFail = error => ({
  type: ADD_PRODUCTBLOCK_FAIL,
  payload: error,
});